// Generated translation dictionary. Keys are the Chinese source strings used in
// the UI; look them up with `t("中文")` from `@/lib/i18n`. Keeping the Chinese
// text as the key means an untranslated string still renders as valid copy.

export const zh = {
  " · 从未使用": " · 从未使用",
  " 记录，指向 ": " 记录，指向 ",
  "）": "）",
  "{f.link_count} 个链接": "{f.link_count} 个链接",
  "{fieldsFilled} 个参数": "{fieldsFilled} 个参数",
  "{n} 条": "{n} 条",
  "📋 复制链接": "📋 复制链接",
  "📱 查看二维码": "📱 查看二维码",
  "📲 DeepLink 尝试": "📲 DeepLink 尝试",
  "🔗 直接打开": "🔗 直接打开",
  "🔗 直接访问": "🔗 直接访问",
  "🚀 浏览器打开": "🚀 浏览器打开",
  "${d.date}: ${d.count} 点击": "${d.date}: ${d.count} 点击",
  "${platforms.length} 种": "${platforms.length} 种",
  "保存": "保存",
  "保存中...": "保存中...",
  "编辑": "编辑",
  "标签": "标签",
  "标签已创建": "标签已创建",
  "标题": "标题",
  "不分类": "不分类",
  "不使用模板": "不使用模板",
  "创建": "创建",
  "创建短链接": "创建短链接",
  "创建链接": "创建链接",
  "创建链接时即可选择已验证的域名": "创建链接时即可选择已验证的域名",
  "创建模板": "创建模板",
  "创建日期": "创建日期",
  "创建失败": "创建失败",
  "创建时间": "创建时间",
  "创建中...": "创建中...",
  "春季推广活动": "春季推广活动",
  "打开链接": "打开链接",
  "待验证": "待验证",
  "当有人点击您的短链时，事件会显示在这里": "当有人点击您的短链时，事件会显示在这里",
  "导出成功": "导出成功",
  "导出失败": "导出失败",
  "登录": "登录",
  "点击": "点击",
  "点击编辑名称": "点击编辑名称",
  "点击次数": "点击次数",
  "点击事件与平台行为记录": "点击事件与平台行为记录",
  "点击统计": "点击统计",
  "点击详情": "点击详情",
  "点击最多": "点击最多",
  "点击最少": "点击最少",
  "洞察": "洞察",
  "独立 IP 数": "独立 IP 数",
  "独立访客统计（按 IP）": "独立访客统计（按 IP）",
  "独立链接": "独立链接",
  "短链": "短链",
  "短链接创建成功！": "短链接创建成功！",
  "短码": "短码",
  "短码: {code}": "短码: {code}",
  "短信": "短信",
  "二维码": "二维码",
  "返回链接列表": "返回链接列表",
  "返回列表": "返回列表",
  "复制参数": "复制参数",
  "复制链接": "复制链接",
  "高级选项": "高级选项",
  "个人信息": "个人信息",
  "更新失败": "更新失败",
  "更新时间": "更新时间",
  "共 {total} 条记录": "共 {total} 条记录",
  "关键词": "关键词",
  "关键词 (term)": "关键词 (term)",
  "管理 UTM 参数模板，创建链接时快速复用": "管理 UTM 参数模板，创建链接时快速复用",
  "管理你的自定义域名": "管理你的自定义域名",
  "过期时间": "过期时间",
  "还没有 UTM 模板": "还没有 UTM 模板",
  "还没有 UTM 模板，去": "还没有 UTM 模板，去",
  "还没有标签": "还没有标签",
  "还没有文件夹": "还没有文件夹",
  "还没有链接": "还没有链接",
  "还没有自定义域名": "还没有自定义域名",
  "活动": "活动",
  "活动 (campaign)": "活动 (campaign)",
  "基本信息": "基本信息",
  "加载链接失败": "加载链接失败",
  "加载失败，请检查网络后重试。": "加载失败，请检查网络后重试。",
  "加载中...": "加载中...",
  "简短描述": "简短描述",
  "客户": "客户",
  "来源": "来源",
  "来源 (source)": "来源 (source)",
  "来源: {refererUrl}": "来源: {refererUrl}",
  "链接": "链接",
  "链接标题": "链接标题",
  "链接不存在": "链接不存在",
  "链接点击数据和概览": "链接点击数据和概览",
  "链接详情": "链接详情",
  "链接已删除": "链接已删除",
  "浏览器": "浏览器",
  "留空则不加密": "留空则不加密",
  "留空则自动生成 8 位随机短码": "留空则自动生成 8 位随机短码",
  "留空自动生成": "留空自动生成",
  "没有匹配的链接": "没有匹配的链接",
  "媒介": "媒介",
  "媒介 (medium)": "媒介 (medium)",
  "每日点击量（近30天）": "每日点击量（近30天）",
  "密码": "密码",
  "密码保护": "密码保护",
  "描述": "描述",
  "模板名称 *": "模板名称 *",
  "模板已创建": "模板已创建",
  "默认": "默认",
  "目标 URL": "目标 URL",
  "内容": "内容",
  "内容 (content)": "内容 (content)",
  "配置自定义域名": "配置自定义域名",
  "批量打标签": "批量打标签",
  "批量打标签失败": "批量打标签失败",
  "批量删除": "批量删除",
  "批量删除失败": "批量删除失败",
  "平均点击": "平均点击",
  "平台": "平台",
  "平台来源": "平台来源",
  "平台来源分布": "平台来源分布",
  "其他": "其他",
  "启用": "启用",
  "启用中": "启用中",
  "请将域名 CNAME 解析到服务器并点击验证": "请将域名 CNAME 解析到服务器并点击验证",
  "取消": "取消",
  "取消选择": "取消选择",
  "全部标签": "全部标签",
  "全部文件夹": "全部文件夹",
  "全选": "全选",
  "确认删除": "确认删除",
  "如何配置？": "如何配置？",
  "删除": "删除",
  "删除？": "删除？",
  "删除标签": "删除标签",
  "删除失败": "删除失败",
  "上一页": "上一页",
  "深度链接": "深度链接",
  "时间": "时间",
  "事件": "事件",
  "手机号": "手机号",
  "数据统计": "数据统计",
  "搜索链接...": "搜索链接...",
  "添加": "添加",
  "添加标签...": "添加标签...",
  "添加失败，域名可能已存在": "添加失败，域名可能已存在",
  "条链接": "条链接",
  "停用": "停用",
  "统计": "统计",
  "微博": "微博",
  "微信": "微信",
  "未命名链接": "未命名链接",
  "未设置": "未设置",
  "文件夹": "文件夹",
  "文件夹已创建": "文件夹已创建",
  "我的推广链接": "我的推广链接",
  "下一页": "下一页",
  "下载": "下载",
  "下载 PNG": "下载 PNG",
  "小红书": "小红书",
  "新建": "新建",
  "新建 UTM 模板": "新建 UTM 模板",
  "新建标签...": "新建标签...",
  "新建模板": "新建模板",
  "新建文件夹...": "新建文件夹...",
  "行为": "行为",
  "修改短码": "修改短码",
  "验证": "验证",
  "验证码": "验证码",
  "验证失败": "验证失败",
  "验证于 ": "验证于 ",
  "验证中...": "验证中...",
  "已复制": "已复制",
  "已复制参数到剪贴板": "已复制参数到剪贴板",
  "已复制到剪贴板": "已复制到剪贴板",
  "已更新": "已更新",
  "已启用": "已启用",
  "已删除": "已删除",
  "已删除 ${selectedIds.size} 条链接": "已删除 ${selectedIds.size} 条链接",
  "已设置": "已设置",
  "已停用": "已停用",
  "已为 ${selectedIds.size} 条链接添加标签": "已为 ${selectedIds.size} 条链接添加标签",
  "已选 {n} 条": "已选 {n} 条",
  "已选 {n} 条链接": "已选 {n} 条链接",
  "已验证": "已验证",
  "已重命名": "已重命名",
  "隐藏高级选项 ▲": "隐藏高级选项 ▲",
  "永不过期": "永不过期",
  "用标签标记和筛选链接": "用标签标记和筛选链接",
  "用户": "用户",
  "用文件夹组织你的短链接": "用文件夹组织你的短链接",
  "域名": "域名",
  "域名已添加": "域名已添加",
  "域名已验证": "域名已验证",
  "在下方添加你的域名（例如 ": "在下方添加你的域名（例如 ",
  "在域名 DNS 管理中添加一条 ": "在域名 DNS 管理中添加一条 ",
  "暂无点击事件": "暂无点击事件",
  "暂无点击数据": "暂无点击数据",
  "暂无访客数据": "暂无访客数据",
  "展开高级选项 ▼": "展开高级选项 ▼",
  "正在跳转...": "正在跳转...",
  "中文": "中文",
  "重命名失败": "重命名失败",
  "重新加载": "重新加载",
  "状态更新失败": "状态更新失败",
  "资源管理": "资源管理",
  "自定义短码": "自定义短码",
  "总点击": "总点击",
  "总点击次数": "总点击次数",
  "总点击数": "总点击数",
  "总链接数": "总链接数",
  "最近访问": "最近访问",
  "最新创建": "最新创建",
  "最早创建": "最早创建",
  "Android 深度链接": "Android 深度链接",
  "App 深度链接": "App 深度链接",
  "DNS 生效后点击「验证」确认域名所有权": "DNS 生效后点击「验证」确认域名所有权",
  "GitHub": "GitHub",
  "iOS 深度链接": "iOS 深度链接",
  "IP 地址": "IP 地址",
  "Token 创建成功": "Token 创建成功",
  "Token 已删除": "Token 已删除",
  "UTM 参数": "UTM 参数",
  "UTM 模板": "UTM 模板",
  // Added with phone-only sign-in: the graphical challenge, the consent line and the policy page.
  "切换到浅色模式": "切换到浅色模式",
  "切换到深色模式": "切换到深色模式",
  "图形验证码": "图形验证码",
  "备案与隐私": "备案与隐私",
  "隐私政策": "隐私政策",
  "最近更新：2026 年 1 月": "最近更新：2026 年 1 月",
  "密码至少 8 位": "密码至少 8 位",
  "至少 8 位字符": "至少 8 位字符",
  "重试": "重试",
  "暂时无法打开会话，请稍后重试。": "暂时无法打开会话，请稍后重试。",
  "返回首页": "返回首页",
  "举报": "举报",
  "举报链接": "举报链接",
  "举报原因": "举报原因",
  "举报已提交": "举报已提交",
  "短链代码": "短链代码",
  "请选择原因": "请选择原因",
  "请填写短链代码": "请填写短链代码",
  "色情内容": "色情内容",
  "赌博": "赌博",
  "毒品": "毒品",
  "诈骗": "诈骗",
  "钓鱼网站": "钓鱼网站",
  "恶意软件": "恶意软件",
  "详细说明": "详细说明",
  "请描述你看到了什么，帮助我们核查": "请描述你看到了什么，帮助我们核查",
  "联系方式（选填）": "联系方式（选填）",
  "邮箱或手机号，仅在需要核实时使用": "邮箱或手机号，仅在需要核实时使用",
  "提交举报": "提交举报",
  "提交中...": "提交中...",
  "提交失败，请稍后重试": "提交失败，请稍后重试",
  "如果你打开的短链接指向违规内容，请告诉我们。我们会在 24 小时内核查。": "如果你打开的短链接指向违规内容，请告诉我们。我们会在 24 小时内核查。",
  "感谢你的反馈，我们会在 24 小时内核查。": "感谢你的反馈，我们会在 24 小时内核查。",
  "该链接已被停止访问": "该链接已被停止访问",
  "分流目标": "分流目标",
  "设置多个目标后，访客会按权重被分流；全部停用或满额时链接不再跳转": "设置多个目标后，访客会按权重被分流；全部停用或满额时链接不再跳转",
  "没有分流目标，访客会直接跳到原目标地址": "没有分流目标，访客会直接跳到原目标地址",
  "权重": "权重",
  "每日上限": "每日上限",
  "添加目标": "添加目标",
  "保存分流": "保存分流",
  "分流目标已保存": "分流目标已保存",
  "保存分流失败": "保存分流失败",
  "上传文件": "上传文件",
  "上传中...": "上传中...",
  "上传失败": "上传失败",
  "文件已上传": "文件已上传",
  "图片或文档，上传后得到一个短链": "图片或文档，上传后得到一个短链",
  "上传二维码": "上传二维码",
  "目标类型": "目标类型",
  "普通链接": "普通链接",
  "微信群二维码": "微信群二维码",
  "有效期": "有效期",
  "有效期至": "有效期至",
  "已过期": "已过期",
  "运营": "运营",
  "访客举报的链接，以及停用和恢复。每一次操作都会记录是谁、为什么。": "访客举报的链接，以及停用和恢复。每一次操作都会记录是谁、为什么。",
  "按短码操作": "按短码操作",
  "停用原因": "停用原因",
  "证据（举报编号或链接）": "证据（举报编号或链接）",
  "停止访问": "停止访问",
  "恢复访问": "恢复访问",
  "查看处理记录": "查看处理记录",
  "已恢复": "已恢复",
  "还没有人举报。": "还没有人举报。",
  "据此停用": "据此停用",
  "访客举报：": "访客举报：",
  "未填写": "未填写",
  "已停止该链接": "已停止该链接",
  "已恢复该链接": "已恢复该链接",
  "操作失败": "操作失败",
  "API": "API",
  "用令牌调用接口，在你自己的程序里创建短链、读取统计。": "用令牌调用接口，在你自己的程序里创建短链、读取统计。",
  "接口地址": "接口地址",
  "认证方式": "认证方式",
  "每个请求带上 Authorization: Bearer <令牌>。令牌在下面创建，只显示一次。": "每个请求带上 Authorization: Bearer <令牌>。令牌在下面创建，只显示一次。",
  "示例代码": "示例代码",
  "复制": "复制",
  "把 kada_your_token 换成你自己的令牌。": "把 kada_your_token 换成你自己的令牌。",
  "令牌只显示一次，创建后请立刻复制。": "令牌只显示一次，创建后请立刻复制。",
  "令牌名称": "令牌名称",
  "新建令牌": "新建令牌",
  "新令牌（只显示这一次）": "新令牌（只显示这一次）",
  "还没有令牌。": "还没有令牌。",
  "输入部署时设置的 ADMIN_SECRET，它只保存在这个浏览器里。": "输入部署时设置的 ADMIN_SECRET，它只保存在这个浏览器里。",
  "运营密钥": "运营密钥",
  "进入": "进入",
  "密钥不对。": "密钥不对。",
  "分流": "分流",
  "把一条短链的访客按权重分给多个目标；没有目标时，链接直接跳到原地址。": "把一条短链的访客按权重分给多个目标；没有目标时，链接直接跳到原地址。",
  "选择链接": "选择链接",
  "选择一条链接，编辑它的分流目标。": "选择一条链接，编辑它的分流目标。",
  "只列出最近的 {n} 条链接": "只列出最近的 {n} 条链接",
  "全部统计": "全部统计",
  "近 30 天点击": "近 30 天点击",
  "平均每日": "平均每日",
  "这条链接的统计读不出来。": "这条链接的统计读不出来。",
  "查看统计": "查看统计",
  "在分流里编辑": "在分流里编辑",
} as const;

export type MessageKey = keyof typeof zh;
export type Messages = Record<MessageKey, string>;

export const en: Messages = {
  " · 从未使用": " · never used",
  " 记录，指向 ": " record pointing at ",
  "）": ")",
  "{f.link_count} 个链接": "{f.link_count} links",
  "{fieldsFilled} 个参数": "{fieldsFilled} parameters",
  "{n} 条": "{n} items",
  "📋 复制链接": "📋 Copy link",
  "📱 查看二维码": "📱 View QR code",
  "📲 DeepLink 尝试": "📲 DeepLink attempt",
  "🔗 直接打开": "🔗 Open directly",
  "🔗 直接访问": "🔗 Direct visit",
  "🚀 浏览器打开": "🚀 Open in browser",
  "${d.date}: ${d.count} 点击": "${d.date}: ${d.count} clicks",
  "${platforms.length} 种": "${platforms.length} types",
  "保存": "Save",
  "保存中...": "Saving...",
  "编辑": "Edit",
  "标签": "Tags",
  "标签已创建": "Tag created",
  "标题": "Title",
  "不分类": "Uncategorized",
  "不使用模板": "No template",
  "创建": "Create",
  "创建短链接": "Create short link",
  "创建链接": "Create link",
  "创建链接时即可选择已验证的域名": "Verified domains can be selected when creating a link",
  "创建模板": "Create template",
  "创建日期": "Created",
  "创建失败": "Create failed",
  "创建时间": "Created",
  "创建中...": "Creating...",
  "春季推广活动": "Spring campaign",
  "打开链接": "Open link",
  "待验证": "Pending",
  "当有人点击您的短链时，事件会显示在这里": "Events appear here when someone clicks your short links",
  "导出成功": "Export succeeded",
  "导出失败": "Export failed",
  "登录": "Sign in",
  "点击": "clicks",
  "点击编辑名称": "Click to rename",
  "点击次数": "Clicks",
  "点击事件与平台行为记录": "Click events and platform behaviour log",
  "点击统计": "Click statistics",
  "点击详情": "Click details",
  "点击最多": "Most clicks",
  "点击最少": "Fewest clicks",
  "洞察": "Insights",
  "独立 IP 数": "Unique IPs",
  "独立访客统计（按 IP）": "Unique visitor stats (by IP)",
  "独立链接": "Unique links",
  "短链": "Short link",
  "短链接创建成功！": "Short link created!",
  "短码": "Short code",
  "短码: {code}": "Short code: {code}",
  "短信": "SMS",
  "二维码": "QR code",
  "返回链接列表": "Back to links",
  "返回列表": "Back to list",
  "复制参数": "Copy parameters",
  "复制链接": "Copy link",
  "高级选项": "Advanced options",
  "个人信息": "Profile",
  "更新失败": "Update failed",
  "更新时间": "Updated",
  "共 {total} 条记录": "{total} records",
  "关键词": "Term",
  "关键词 (term)": "Term (term)",
  "管理 UTM 参数模板，创建链接时快速复用": "Manage UTM parameter templates and reuse them when creating links",
  "管理你的自定义域名": "Manage your custom domains",
  "过期时间": "Expiry",
  "还没有 UTM 模板": "No UTM templates yet",
  "还没有 UTM 模板，去": "No UTM templates yet — go to ",
  "还没有标签": "No tags yet",
  "还没有文件夹": "No folders yet",
  "还没有链接": "No links yet",
  "还没有自定义域名": "No custom domains yet",
  "活动": "Campaign",
  "活动 (campaign)": "Campaign (campaign)",
  "基本信息": "Basic information",
  "加载链接失败": "Failed to load link",
  "加载失败，请检查网络后重试。": "Failed to load. Check your connection and try again.",
  "加载中...": "Loading...",
  "简短描述": "Short description",
  "客户": "Customers",
  "来源": "Source",
  "来源 (source)": "Source (source)",
  "来源: {refererUrl}": "Source: {refererUrl}",
  "链接": "Links",
  "链接标题": "Link title",
  "链接不存在": "Link not found",
  "链接点击数据和概览": "Link click data and overview",
  "链接详情": "Link details",
  "链接已删除": "Link deleted",
  "浏览器": "Browser",
  "留空则不加密": "Leave blank for no password",
  "留空则自动生成 8 位随机短码": "Leave blank to generate a random 8-character short code",
  "留空自动生成": "Leave blank to generate",
  "没有匹配的链接": "No matching links",
  "媒介": "Medium",
  "媒介 (medium)": "Medium (medium)",
  "每日点击量（近30天）": "Daily clicks (last 30 days)",
  "密码": "Password",
  "密码保护": "Password protection",
  "描述": "Description",
  "模板名称 *": "Template name *",
  "模板已创建": "Template created",
  "默认": "Default",
  "目标 URL": "Target URL",
  "内容": "Content",
  "内容 (content)": "Content (content)",
  "配置自定义域名": "Configure a custom domain",
  "批量打标签": "Bulk tag",
  "批量打标签失败": "Bulk tagging failed",
  "批量删除": "Bulk delete",
  "批量删除失败": "Bulk delete failed",
  "平均点击": "Average clicks",
  "平台": "Platform",
  "平台来源": "Platform sources",
  "平台来源分布": "Platform source breakdown",
  "其他": "Other",
  "启用": "Enable",
  "启用中": "Active",
  "请将域名 CNAME 解析到服务器并点击验证": "Point the domain's CNAME at the server, then click Verify",
  "取消": "Cancel",
  "取消选择": "Clear selection",
  "全部标签": "All tags",
  "全部文件夹": "All folders",
  "全选": "Select all",
  "确认删除": "Confirm delete",
  "如何配置？": "How do I configure this?",
  "删除": "Delete",
  "删除？": "Delete?",
  "删除标签": "Delete tag",
  "删除失败": "Delete failed",
  "上一页": "Previous",
  "深度链接": "Deep links",
  "时间": "Time",
  "事件": "Events",
  "手机号": "Phone number",
  "数据统计": "Statistics",
  "搜索链接...": "Search links...",
  "添加": "Add",
  "添加标签...": "Add tag...",
  "添加失败，域名可能已存在": "Failed to add — the domain may already exist",
  "条链接": "links",
  "停用": "Disable",
  "统计": "Statistics",
  "微博": "Weibo",
  "微信": "WeChat",
  "未命名链接": "Untitled link",
  "未设置": "Not set",
  "文件夹": "Folders",
  "文件夹已创建": "Folder created",
  "我的推广链接": "My campaign link",
  "下一页": "Next",
  "下载": "Download",
  "下载 PNG": "Download PNG",
  "小红书": "Xiaohongshu",
  "新建": "New",
  "新建 UTM 模板": "New UTM template",
  "新建标签...": "New tag...",
  "新建模板": "New template",
  "新建文件夹...": "New folder...",
  "行为": "Action",
  "修改短码": "Change short code",
  "验证": "Verify",
  "验证码": "Verification code",
  "验证失败": "Verification failed",
  "验证于 ": "Verified on ",
  "验证中...": "Verifying...",
  "已复制": "Copied",
  "已复制参数到剪贴板": "Parameters copied to clipboard",
  "已复制到剪贴板": "Copied to clipboard",
  "已更新": "Updated",
  "已启用": "Enabled",
  "已删除": "Deleted",
  "已删除 ${selectedIds.size} 条链接": "Deleted ${selectedIds.size} links",
  "已设置": "Set",
  "已停用": "Disabled",
  "已为 ${selectedIds.size} 条链接添加标签": "Tagged ${selectedIds.size} links",
  "已选 {n} 条": "{n} selected",
  "已选 {n} 条链接": "{n} links selected",
  "已验证": "Verified",
  "已重命名": "Renamed",
  "隐藏高级选项 ▲": "Hide advanced options ▲",
  "永不过期": "Never expires",
  "用标签标记和筛选链接": "Tag and filter your links",
  "用户": "Account",
  "用文件夹组织你的短链接": "Organise your short links with folders",
  "域名": "Domains",
  "域名已添加": "Domain added",
  "域名已验证": "Domain verified",
  "在下方添加你的域名（例如 ": "Add your domain below (for example ",
  "在域名 DNS 管理中添加一条 ": "Add a ",
  "暂无点击事件": "No click events yet",
  "暂无点击数据": "No click data yet",
  "暂无访客数据": "No visitor data yet",
  "展开高级选项 ▼": "Show advanced options ▼",
  "正在跳转...": "Redirecting...",
  "中文": "中文",
  "重命名失败": "Rename failed",
  "重新加载": "Reload",
  "状态更新失败": "Failed to update status",
  "资源管理": "Resources",
  "自定义短码": "Custom short code",
  "总点击": "Total clicks",
  "总点击次数": "Total clicks",
  "总点击数": "Total clicks",
  "总链接数": "Total links",
  "最近访问": "Last seen",
  "最新创建": "Newest first",
  "最早创建": "Oldest first",
  "Android 深度链接": "Android deep link",
  "App 深度链接": "App deep links",
  "DNS 生效后点击「验证」确认域名所有权": "Click Verify once DNS has propagated to confirm domain ownership",
  "GitHub": "GitHub",
  "iOS 深度链接": "iOS deep link",
  "IP 地址": "IP address",
  "Token 创建成功": "Token created",
  "Token 已删除": "Token deleted",
  "UTM 参数": "UTM parameters",
  "UTM 模板": "UTM templates",
  // Added with phone-only sign-in: the graphical challenge, the consent line and the policy page.
  "切换到浅色模式": "Switch to light mode",
  "切换到深色模式": "Switch to dark mode",
  "图形验证码": "Verification image",
  "备案与隐私": "Filings & privacy",
  "隐私政策": "Privacy Policy",
  "最近更新：2026 年 1 月": "Last updated: January 2026",
  "密码至少 8 位": "The password must be at least 8 characters",
  "至少 8 位字符": "At least 8 characters",
  "重试": "Try again",
  "暂时无法打开会话，请稍后重试。": "Could not open a session. Please try again shortly.",
  "返回首页": "Back to home",
  "举报": "Report",
  "举报链接": "Report a link",
  "举报原因": "Reason",
  "举报已提交": "Report received",
  "短链代码": "Short code",
  "请选择原因": "Choose a reason",
  "请填写短链代码": "Enter the short code",
  "色情内容": "Pornography",
  "赌博": "Gambling",
  "毒品": "Drugs",
  "诈骗": "Fraud",
  "钓鱼网站": "Phishing",
  "恶意软件": "Malware",
  "详细说明": "What you saw",
  "请描述你看到了什么，帮助我们核查": "Describe what the link showed, so we can check it",
  "联系方式（选填）": "Contact (optional)",
  "邮箱或手机号，仅在需要核实时使用": "An email or phone number, only if we need to ask you something",
  "提交举报": "Submit the report",
  "提交中...": "Submitting...",
  "提交失败，请稍后重试": "Could not submit the report. Please try again shortly.",
  "如果你打开的短链接指向违规内容，请告诉我们。我们会在 24 小时内核查。": "If a short link you opened leads somewhere illegal, tell us. We look at reports within 24 hours.",
  "感谢你的反馈，我们会在 24 小时内核查。": "Thank you - we look at reports within 24 hours.",
  "该链接已被停止访问": "This link has been stopped",
  "分流目标": "Split targets",
  "设置多个目标后，访客会按权重被分流；全部停用或满额时链接不再跳转": "With more than one target, visitors are split by weight. If every target is disabled or full, the link stops resolving.",
  "没有分流目标，访客会直接跳到原目标地址": "No split targets - visitors go straight to the original destination.",
  "权重": "Weight",
  "每日上限": "Daily cap",
  "添加目标": "Add target",
  "保存分流": "Save targets",
  "分流目标已保存": "Targets saved",
  "保存分流失败": "Could not save the targets",
  "上传文件": "Upload a file",
  "上传中...": "Uploading...",
  "上传失败": "Upload failed",
  "文件已上传": "File uploaded",
  "图片或文档，上传后得到一个短链": "An image or a document - you get a short link for it",
  "上传二维码": "Upload code",
  "目标类型": "Target type",
  "普通链接": "Plain link",
  "微信群二维码": "WeChat group code",
  "有效期": "Expires",
  "有效期至": "Valid until",
  "已过期": "Expired",
  "运营": "Moderation",
  "访客举报的链接，以及停用和恢复。每一次操作都会记录是谁、为什么。": "Links visitors reported, and stopping or restoring them. Every action records who did it and why.",
  "按短码操作": "Act on a short code",
  "停用原因": "Reason",
  "证据（举报编号或链接）": "Evidence (a report id or a link)",
  "停止访问": "Stop serving",
  "恢复访问": "Restore",
  "查看处理记录": "Show the history",
  "已恢复": "restored",
  "还没有人举报。": "Nothing has been reported yet.",
  "据此停用": "Stop it for this reason",
  "访客举报：": "Visitor report: ",
  "未填写": "not stated",
  "已停止该链接": "The link is stopped",
  "已恢复该链接": "The link is restored",
  "操作失败": "That did not work",
  "API": "API",
  "用令牌调用接口，在你自己的程序里创建短链、读取统计。": "Call the API with a token to create links and read statistics from your own program.",
  "接口地址": "Base URL",
  "认证方式": "Authentication",
  "每个请求带上 Authorization: Bearer <令牌>。令牌在下面创建，只显示一次。": "Send Authorization: Bearer <token> with every request. Tokens are created below and shown once.",
  "示例代码": "Examples",
  "复制": "Copy",
  "把 kada_your_token 换成你自己的令牌。": "Replace kada_your_token with your own token.",
  "令牌只显示一次，创建后请立刻复制。": "A token is shown once - copy it right after creating it.",
  "令牌名称": "Token name",
  "新建令牌": "New token",
  "新令牌（只显示这一次）": "New token (shown once)",
  "还没有令牌。": "No tokens yet.",
  "输入部署时设置的 ADMIN_SECRET，它只保存在这个浏览器里。": "Enter the ADMIN_SECRET configured on the deployment. It is kept in this browser only.",
  "运营密钥": "Operator secret",
  "进入": "Enter",
  "密钥不对。": "That secret is not right.",
  "分流": "Routing",
  "把一条短链的访客按权重分给多个目标；没有目标时，链接直接跳到原地址。": "Send one link's visitors to several destinations by weight. With no targets, the link goes straight to its original URL.",
  "选择链接": "Choose a link",
  "选择一条链接，编辑它的分流目标。": "Pick a link to edit its targets.",
  "只列出最近的 {n} 条链接": "Only the {n} most recent links are listed.",
  "全部统计": "All statistics",
  "近 30 天点击": "Clicks in the last 30 days",
  "平均每日": "Daily average",
  "这条链接的统计读不出来。": "This link's statistics could not be read.",
  "查看统计": "View statistics",
  "在分流里编辑": "Edit under Routing",
};
